const GA_TRACKING_ID = "G-LL3NDTF8KK"

export const sendGAPageview = (title: string, path: string) => {
	console.log(`sendGAPageview ${title} ${path}`)
	if (typeof window !== "undefined" && window.gtag) {
		window.gtag("event", "page_view", {
			page_title: title,
			page_path: path,
			send_to: GA_TRACKING_ID,
		})
	}
}
